import { ImageStyle } from 'expo-image'
import { memo } from 'react'
import { StyleProp } from 'react-native'

import UniImage from '@/components/unistyles/UniImage'
import Species from '@/enums/species'

interface Props {
  blurhash: string | null | undefined
  thumbUri: string | null | undefined
  species: Species
  style: StyleProp<ImageStyle>
  transition?: number
}

const FosterThumbnail = ({
  blurhash,
  thumbUri,
  species,
  style,

  transition,
}: Props) => {
  const thumbnail = blurhash
    ? thumbUri
    : species === 'Cat'
      ? require('../../../assets/cat.png')
      : require('../../../assets/dog.png')

  return (
    <UniImage
      accessibilityIgnoresInvertColors={true}
      cachePolicy={blurhash ? 'memory' : 'none'}
      contentFit="cover"
      key={thumbUri}
      placeholder={{ blurhash: blurhash || undefined }}
      placeholderContentFit="cover"
      recyclingKey={thumbUri}
      source={thumbnail}
      style={style}
      testID="foster-image"
      transition={transition || 0}
    />
  )
}

export default memo(FosterThumbnail)
